import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, loadOptions, showField, editable, imageDimension }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    loadOptions,
    showField,
    editable,
    imageDimension
  }))
 )
}

export const fields: any = {
  centralizedBanner: mapFields(
    drilldownData["centralizedBanner"]
  ),
  centralizedBannerTags: mapFields(drilldownData["centralizedBannerTags"]),
  centralizedBannerType: mapFields(drilldownData["centralizedBannerType"])
};
